import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	card: {
		padding: "24px",
		minHeight: "150px",
		boxShadow: "none"
	},
	cardTitle: {
		fontSize: "32px",
		fontWeight: 700
	},
	cardSubtitle: {
		fontSize: "16px",
		marginTop: "8px",
		color: "inherit"
	},
	allTimeSubtitle: {
		fontSize: "12px",
		marginTop: "4px",
		color: "inherit",
		opacity: 0.7
	},
	purple: {
		color: colors.purple[600],
		background: colors.purple[100]
	},
	green: {
		color: colors.green[600],
		background: colors.green[100]
	},
	blue: {
		color: colors.blue[600],
		background: colors.blue[100]
	}
}))

export default useStyles
